import React, { useState, useEffect } from "react";
import Button from '../../components/Button';
import './FeedBack.scss';
import { toast } from 'react-toastify';
import * as client from '../../services/client';
import Textarea from '../../components/Textarea';
import { connect } from 'react-redux';

const FeedBack = () => {
const [rating, setRating] = useState(0);
const [hover, setHover] = useState(0);
const deselectedIcon = '☆';
const selectedIcon = '★';
const [isShowPopUp, setIsShowPopUp] = useState(false);
const stars=[1,2,3,4,5];
const [notes, setNotes] = useState('');

useEffect(()=> {
  const ServiceRequestDetails=JSON.parse(localStorage.getItem("IsHomerNavigatFromFeedBackTemplate"));
  if (ServiceRequestDetails?.ServiceRequestId) {
    validateCustomerFeedback(ServiceRequestDetails?.ServiceRequestId)
  }

} , [])

const validateCustomerFeedback = async(ServiceRequestId) => {
  const response = await client.ValidateCustomerFeedback(ServiceRequestId);
  if (response.ok || response.status === 200) {
    response.json().then(
      (responsejson) => {
        if (responsejson.statusCode === 200) {
          setIsShowPopUp(true)

        } else if (responsejson.statusCode === 400) {
          setIsShowPopUp(false)
          toast.success(responsejson.message, {
            autoClose: 5000,
            position: "top-center",
          });
          localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate')
          
        }
      }
    );
  }
}
const close=()=>{setIsShowPopUp(false);}
const buttonDisabled=(!!rating);
const  feedBackSubmit=async ()=>{
  try {
   const userDetails=JSON.parse(localStorage.getItem("user"));
   const ServiceRequestDetails=JSON.parse(localStorage.getItem("IsHomerNavigatFromFeedBackTemplate"));
    const params={ 
      ServiceRequestId: ServiceRequestDetails?.ServiceRequestId,
      Rating:rating.toString(),
      Feedback: notes,
      CreatedBy:userDetails.id
  }

    const response = await client.saveCustomerFeedback(params);
    if (response.ok || response.status === 200) {
      response.json().then(
        (responsejson) => {
          if (responsejson.statusCode === 200) {
            setIsShowPopUp(false);
            localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate');
            toast.success("Feedback submitted sucessfully.", {
              autoClose: 5000,
              position: "top-center",
            });

          } else {
            toast.error("Sorry, cannot submitted feedback at this time. Please try again later.", {
              autoClose: 5000,
              position: "top-center",
            });
          }
        }
      );
    } else {
    }
  } catch {
  }
}
  return (
    <>
     {
     isShowPopUp ?
      <div className="modalContainer" onClick={() => close()}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <header className="modal_header">
            <h2 className="modal_header-title" style={{textAlign:"left"}}>Feedback</h2>
            <div className="filters_modal_close_icon" onClick={() => close()}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z" fill="black"/>
            </svg>
           
          </div>
          </header>
          <main className="modal_content">
         
          <div class="row">
              <div class="col-md-12">
              Please provide a rating on your experience, and include any comments below.
                <div class="form-group">
                <div className="rating" style={{ fontSize: '2em', color: "#FFA41C" }}>
              {stars.map(star => {
                return (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => setRating(star)}
                        onMouseEnter={() =>  setHover(star)}
                        onMouseLeave={() => setHover(0)}
                    >
                        {rating < star ?
                            hover < star ? deselectedIcon : selectedIcon
                            :
                            selectedIcon
                        }
                    </span>
                );
              })}
          </div>
          <div style={{marginTop:"15px"}}>
          <Textarea  rows="3"   value = {notes} onChange={e => setNotes(e.target.value)} />
          </div>
                </div>
              </div>
            </div>
          </main>
          <footer className="modal_footer">
          <Button  color="teal" disabled={!buttonDisabled}
               size="small"  onClick={() => {feedBackSubmit(); close();}}
                label="Submit"
          ></Button>
          </footer> 
        </div>
      </div>
      : null
     }
    </>
  );
};
const mapStateToProps = state => ({
  userId: state,
 
});
export default connect(mapStateToProps)(FeedBack);